export default {
    emailFormatsList: [],
    systemMessagesList: [],
};
